<template>
	<div class="btngroup">
		<div class="chackbox" :style="{ marginRight: `${ marginRight }` }" v-if="chackbox">
			<el-checkbox v-model="checkeds">{{ checktitle }}</el-checkbox>
		</div>
		<div class="chackboxtow" :style="{ marginRight: `${ marginRight }` }" v-if="chackboxtow">
			<el-checkbox v-model="checkedTow">{{ checktitleTow }}</el-checkbox>
		</div>
		<button class="btnreset" @click="reset">
			重置
		</button>
		<button class="btnselect" @click="select">
			{{expt?'导出':'查询'}}
		</button>
		<div style="display: inline-block;" v-if="qhide">
			<div class="btns" v-if="show" @click="hide">
				收起<img src="../assets/icon/up.png" style="width: 19.5px;height: 19.5px;vertical-align: middle;" />
			</div>
			<div class="btns" @click="showclick" v-else>
				展开<img src="../assets/icon/down.png" style="width: 19.5px;height: 19.5px;vertical-align: middle;" />
			</div>
		</div>

	</div>
</template>

<script>
	export default {
		props: {
			// 是否显示收起
			show: {
				type: Boolean,
				default: true
			},
			// 是否出现复选库存
			chackbox: {
				type: Boolean,
				default: false
			},
			chackboxtow: {
				type: Boolean,
				default: false
			},
			qhide: {
				type: Boolean,
				default: true
			},
			marginRight: {
				type: String,
				default: "115px"
			},
			checktitle: {
				type: String,
				default: "不显示0库存"
			},
			checktitleTow: {
				type: String,
				default: "是否显示过效期库存"
			},
			checked: {
				type: Boolean,
				default: false
			},
			expt: {
				type: Boolean,
				default: false
			}
		},

		data() {
			return {
				checkeds: this.checked,
				checkedTow: false
			}
		},
		mounted() {},
		methods: {
			reset() {
				this.$emit('reset')
			},
			select() {
				this.$emit('select')
			},
			hide() {
				this.$emit('hide')
			},
			showclick() {
				this.$emit('showclick')
			}
		},
	}
</script>
<style scoped lang="less">
	@import "../style/mixin.less";

	// 添加颜色类
	/deep/.el-radio__input.is-checked+.el-radio__label {
		color: #e71d43 !important;
	}

	/deep/.el-radio__input.is-checked .el-radio__inner {
		background: #e71d43 !important;
		border-color: #e71d43 !important;
	}

	// /deep/.el-checkbox {
	// 	width: 95px;
	// 	text-align: left;
	// }

	/deep/.el-checkbox__input.is-checked .el-checkbox__inner,
	.el-checkbox__input.is-indeterminate .el-checkbox__inner {
		background-color: #e71d43;
		border-color: #e71d43;
	}

	/deep/.el-checkbox__input.is-checked+.el-checkbox__label {
		color: #e71d43;
	}

	/deep/.el-checkbox.is-bordered.is-checked {
		border-color: #e71d43;
	}

	/deep/.el-checkbox__input.is-focus .el-checkbox__inner {
		border-color: #e71d43;
	}

	.btngroup {
		font-size: 14px;
		float: right;
		margin-right: 15px;
		margin-top: 10px;
		user-select: none;

		.btnreset {
			width: 64px;
			height: 32px;
			border: 1px solid #e6e6e6;
			background-color: #fff;
			border-radius: 2px;
			text-align: center;
			// line-height: 32px;
			display: inline-block;
			cursor: pointer;
		}

		.btnreset:hover {
			background-color: #f9f9f9;
		}

		.btnreset:active {
			background-color: #f3f3f3;
		}

		.btnselect {
			width: 64px;
			height: 32px;
			border: 1px solid #e6e6e6;
			border-radius: 2px;
			text-align: center;
			// line-height: 32px;
			color: #fff;
			background-color: #e71d43;
			display: inline-block;
			margin-left: 10px;
			cursor: pointer;
			opacity: 1;
		}

		.btnselect:hover {
			background-color: #e03f5d;
		}

		.btnselect:active {
			background-color: #c01837;
		}

		.btns {
			// width: 64px;
			height: 32px;
			border-radius: 2px;
			text-align: right;
			line-height: 32px;
			color: #e71d43;
			display: inline-block;
			margin-left: 10px;
			// margin-top: 10px;
			cursor: pointer;
			// border: 1px solid red;
		}

		.chackbox {
			display: inline-block;
			// border: 1px solid red;
			margin-right: 115px;
			font-size: 14px;
			color: #333333;
		}

		.chackboxtow {
			display: inline-block;
			// border: 1px solid red;
			margin-right: 115px;
			font-size: 14px;
			color: #333333;
		}
	}
</style>